<template>
  <span :class="`badge text-bg${getStatusBadge(paymentStatus)}`">{{ displayText }}</span>
</template>

<script>
export default {
  name: "PaymentStatusBadge",
  props: {
    paymentStatus: String,
    /** API `statusKo` — 있으면 서버 문구를 그대로 표시 */
    statusKo: String,
  },
  computed: {
    displayText() {
      return this.statusKo || this.getStatus(this.paymentStatus)
    },
  },
  methods: {
    getStatusBadge(status) {
      if (status === "waiting" || status === "vbank_issued") return "-secondary"
      else if(status === "complete") return "-success"
      else if(status === "refund" || status === "partial_refund") return "-danger"
      else if(status === "canceled") return "-warning"
      else if(status === "error") return "-danger"
      else return "-warning"
    },
    getStatus(status){
      if (status === "waiting") return "대기"
      else if(status === "vbank_issued") return "입금 대기중"
      else if(status === "complete") return "결제 완료"
      else if(status === "refund") return "환불"
      else if (status === "partial_refund") return "부분 환불"
      else if(status === "canceled") return "취소"
      else if(status === "error") return "오류"
      else return "실패"
    },
  }
}
</script>

<style scoped>
.text-bg-primary{
  color: #fff!important;
  background-color: RGBA(13,110,253,var(--bs-bg-opacity,1))!important;
}
.text-bg-secondary{
  color: #fff!important;
  background-color: RGBA(108,117,125,var(--bs-bg-opacity,1))!important;
}
.text-bg-success{
  olor: #fff!important;
  background-color: RGBA(25,135,84,var(--bs-bg-opacity,1))!important;
}
.text-bg-danger{
  color: #fff!important;
  background-color: RGBA(220,53,69,var(--bs-bg-opacity,1))!important;
}
.text-bg-warning{
  color: #000!important;
  background-color: RGBA(255,193,7,var(--bs-bg-opacity,1))!important;
}
</style>